export default "__VITE_ASSET__6e32bbdf__"